import { ToolbarItem, UtilityButton } from '@kinesis/bungle';
import { Link } from 'react-router-dom';
import { isNil } from 'lodash/fp';
import styled from 'styled-components';
import { useBreadcrumbs } from '@/hooks/use-breadcrumbs';
import { useInventoryId } from '@/hooks/use-inventory-id';
import { useMaybeScenarioId } from '@/hooks/use-scenario-id';
import { useGetScenarioQuery } from '@/api/scenarios';

const StyledBreadcrumbText = styled('div')(({ theme }: any) => ({
  fontSize: theme.fontSize.lg,
  fontWeight: theme.fontWeight.medium,
  color: theme.color.gray9,
}));

const BreadcrumbSeparator = styled('span')(({ theme }: any) => ({
  color: theme.color.gray6,
}));

const Segment = (props: SegmentProps) => {
  return (
    <>
      <ToolbarItem>
        <BreadcrumbSeparator>/</BreadcrumbSeparator>
      </ToolbarItem>
      <ToolbarItem>
        <UtilityButton magnitude={'medium'} as={Link} to={props.to}>
          <StyledBreadcrumbText>{props.label}</StyledBreadcrumbText>
        </UtilityButton>
      </ToolbarItem>
    </>
  );
};

type SegmentProps = {
  to: string;
  label: string;
};
const Breadcrumbs = (props: BreadcrumbsProps) => {
  const { currentNav, currentNavLink } = props;
  const inventoryId = useInventoryId();
  const scenarioId = useMaybeScenarioId();
  const crumbs = useBreadcrumbs();
  const {
    data: scenario,
    isLoading: isLoadingScenario,
    isSuccess: isSuccessScenario,
  } = useGetScenarioQuery(scenarioId as any, {
    skip: isNil(scenarioId) || !crumbs.includes('scenario'),
  });

  return (
    <>
      <ToolbarItem>
        <UtilityButton magnitude={'medium'} as={Link} to={currentNavLink}>
          <StyledBreadcrumbText>{currentNav}</StyledBreadcrumbText>
        </UtilityButton>
      </ToolbarItem>
      {crumbs.includes('scenario') &&
        isSuccessScenario &&
        !isLoadingScenario && (
          <Segment
            to={`/communities/${inventoryId}/pathways/${scenarioId}`}
            label={scenario.name}
          />
        )}
    </>
  );
};

export type BreadcrumbsProps = {
  currentNav?: string;
  currentNavLink?: string;
};

export { Breadcrumbs };
